/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GroupWiseCount {
    getFixupPrototypeFunction() { return GroupWiseCount.fixupPrototype; }

    static newInstance(model: Partial<GroupWiseCount>): GroupWiseCount {
        let obj = Object.assign(new GroupWiseCount(), model);
        GroupWiseCount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GroupWiseCount>): GroupWiseCount {
        if (!model) return null;
        return GroupWiseCount.newInstance(<GroupWiseCount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GroupWiseCount) {
        if (!obj) return;

        models.GroupWiseCount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GroupWiseCount): boolean {
        Object.setPrototypeOf(obj, GroupWiseCount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.error === undefined) {
            this.error = 0;
        }
        if (this.violations === undefined) {
            this.violations = 0;
        }
        if (this.success === undefined) {
            this.success = 0;
        }
        if (this.open === undefined) {
            this.open = 0;
        }
    }

    /**
     * Count of resources with error status
     */
    error: number;

    /**
     * Count of resources with violations
     */
    violations: number;

    /**
     * Count of resources with success status
     */
    success: number;

    /**
     * Count of resources with open status
     */
    open: number;

}
